exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.block[data-v-09bd4687] {\n  border-top: 1px solid #cccccc;\n}\n.delimiter[data-v-09bd4687] {\n  color: #ccc;\n}\n.pr:last-child .delimiter[data-v-09bd4687] {\n  display: none;\n}\n.about-to-start .status[data-v-09bd4687] {\n  margin-bottom: 5px;\n  color: orange;\n}\n.in-progress .status[data-v-09bd4687] {\n  margin-bottom: 5px;\n  color: green;\n}\n.in-progress[data-v-09bd4687] {\n  padding-top: 10px;\n}\n", ""]);

// exports
